import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  Dropdown,
  DropdownToggle,
  DropdownContent,
} from '@prisjakt/ui/dropdown';
import AppliedFilters from '../applied-filters';

import Section from '../section';

import {
  Filter,
  InitialFilters,
  SearchFacetType,
} from 'src/areas/search/components/results/types';
import { AppliedFilter } from '../applied-filters/types';

import * as S from './styles';

type DesktopProps = {
  appliedFilters: AppliedFilter[];
  clearAllFilters: () => void;
  clearSingleFilter: (id: string, type: SearchFacetType) => void;
  filters: Filter[];
  onFilterOptionToggle: (
    id: string,
    type: SearchFacetType,
    itemId: string | null,
    values: (string | number)[]
  ) => void;
  selectedFilters: InitialFilters | {};
};

export const FiltersDesktop = (props: DesktopProps) => {
  const {
    appliedFilters,
    clearAllFilters,
    clearSingleFilter,
    filters,
    onFilterOptionToggle,
    selectedFilters,
  } = props;

  const { t } = useContext(AppContext);

  if (!filters.length) return null;

  return (
    <>
      <S.FiltersDesktop>
        {filters.map(
          filter =>
            filter.options.length > 0 && (
              <Dropdown key={filter.title}>
                <DropdownToggle
                  showActiveIcon
                  containerProps={{ 'data-test': 'FeaturedFilterButton' }}
                >
                  {filter.title}
                </DropdownToggle>
                <DropdownContent width={360}>
                  <Section
                    id={filter.id}
                    onFilterOptionToggle={(itemId, facetType, values) =>
                      onFilterOptionToggle(
                        filter.id,
                        filter.type,
                        itemId,
                        values
                      )
                    }
                    options={filter.options}
                    selectedFilters={selectedFilters}
                    title={filter.title}
                    type={filter.type}
                  />
                </DropdownContent>
              </Dropdown>
            )
        )}
      </S.FiltersDesktop>

      <S.AppliedFiltersWrapper data-test="AppliedFiltersWrapper">
        <AppliedFilters
          filters={appliedFilters}
          title={`${t('filter', 'applied-filters.title')}:`}
          clearAllFilters={clearAllFilters}
          onClearFilter={(id, type) => clearSingleFilter(id, type)}
        />
      </S.AppliedFiltersWrapper>
    </>
  );
};
